//export default {
//  base_url: 'https://dev-seen.gps.id/backend', // dir seen
//  endpoint: 'https://dev-portal.gps.id/backend/seen', //seen
//  socket: 'wss://ws.gps.id:9443/ws',
//  pulsa: 'https://pulsa2.gps.id/auth',

//  portal_host: 'https://dev-portal.gps.id/backend/api', //portal -> Auth
//  portal_url: 'https://dev-portal.gps.id',
//  command: 'https://ws.gps.id:8081'
//}

export default {
  base_url: 'https://dev-seen.gps.id/backend', // dir seen
  endpoint: 'https://dev-portal.gps.id/backend/seen', //seen
  socket: 'wss://ws.gps.id:9443/ws',
  socket_alert: 'wss://ws.gps.id:8443/ws',
  pulsa: 'https://pulsa2-dev.gps.id/auth',
  sspoin: 'https://dev-sspoin.gps.id/login',
  sspoin_host: 'https://dev-sspoin.gps.id',

  portal_host: 'https://dev-portal.gps.id/backend/api', //portal -> Auth
  portal_url: 'https://dev-portal.gps.id',
  command: 'https://ws.gps.id:8081',
  getaddress: 'http://address.gps.id:8180/reverse.php',
  config_iothub: 'https://api-apps.gps.id/iothub/api',
  connect_iothub: 'https://iothub.gps.id/media',
  new_socket: 'wss://ws.gps.id:19000',
  get_client_ip: 'https://api-apps.gps.id/echoip/json',

  driving_score_grade_ffi_good: 'Good Driver',
  driving_score_grade_ffi_fair: 'Fair Driver',
  driving_score_grade_ffi_bad: 'Bad Driver',
  driving_score_grade_ffi_very_bad: 'Not Recommended to Drive'
}
